<template>
    <div id="packages">     
        <section class="package_table" id="internet">
            <div class="container">
                <div class="row">
                    <div class="col-md-5">
                        <div class="row h-100">
                            <div class="col-sm-12 align-self-center">
                                <div class="title">
                                    <h3>Өрх гэрийн өндөр хурдны "Nomadic" интернетийн багцууд</h3>
                                    <div class="underline"></div>
                                    <p>Гaзарзүйн байрлал хармаарахгүй өндөр хурдны интернет. Монгол орны хаана ч хүлээн авах боломжтой.</p>
                                </div><!--/.title-->
                            </div>
                        </div>
                        
                    </div>
                    <div class="col-md-7">
                        <div class="swiper-container">
                            <div class="swiper-wrapper">

                                <div class="swiper-slide">
                                <div class="table_single">
                                        <div class="table_head">
                                            <h3>Дата багц 1</h3>
                                            <h4>₮70.500/</h4>
                                        </div>
                                        <ul>
                                            <li>30 хоног</li>
                                            <li>3 GB Дата</li>
                                            <li>3000 нэгж</li>                                       
                                        </ul>
                                        <a href="#" class="btn">АВАХ</a>
                                    </div><!--/.table_single-->
                                </div>
                                <div class="swiper-slide">
                                <div class="table_single">
                                       <div class="table_head">
                                            <h3>Дата багц 2</h3>
                                            <h4>₮110.500/</h4>
                                        </div>
                                        <ul>
                                            <li>30 хоног</li>
                                            <li>5 GB Дата</li>
                                            <li>3000 нэгж</li>
                                        </ul>
                                        <a href="#" class="btn">АВАХ</a>
                                    </div><!--/.table_single-->
                                </div>
                                <div class="swiper-slide">
                                <div class="table_single">
                                        <div class="table_head">
                                            <h3>Дата багц 3</h3>
                                            <h4>₮208.500/</h4>
                                        </div>
                                        <ul>
                                            <li>30 хоног</li>
                                            <li>10 GB Дата</li>
                                            <li>3000 нэгж</li>
                                        </ul>
                                        <a href="#" class="btn">АВАХ</a>
                                    </div><!--/.table_single-->
                                </div>
                                <div class="swiper-slide">
                                <div class="table_single">
                                        <div class="table_head">
                                            <h3>Дата багц 4</h3>
                                            <h4>₮299.500/</h4>
                                        </div>
                                        <ul>
                                            <li>30 хоног</li>
                                            <li>15 GB Дата</li>
                                            <li>3000 нэгж</li>
                                        </ul>
                                        <a href="#" class="btn">АВАХ</a>
                                    </div><!--/.table_single-->
                                </div>
                                <div class="swiper-slide">
                                <div class="table_single">
                                        <div class="table_head">
                                            <h3>Дата багц 5</h3>
                                            <h4>₮1,950.000/</h4>
                                        </div>
                                        <ul>
                                            <li>30 хоног</li>
                                            <li>100 GB Дата</li>
                                            <li>3000 нэгж</li>
                                        </ul>
                                        <a href="#" class="btn">АВАХ</a>
                                    </div><!--/.table_single-->
                                </div>
                            </div><!--/.swiper-wrapper-->
                        
                        </div>
                    </div>
                </div>
            </div><!--/.container-->
          <Items/>
        </section>
  </div>
</template>

<script>
import Items from "@/components/Items.vue";

export default {
  name: "packages",
  components: {
    Items
  }
};
</script>